import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MFiveWhys } from 'src/app/shared/models/five-why-item.model';
import { MCause } from 'src/app/shared/models/cause.model';
import { AnalisisMethod } from 'src/app/shared/interfaces/treatment';
import { MCauseArray } from 'src/app/shared/models/cause-array.model';


@Component({
  selector: 'app-method-five-because',
  templateUrl: './method-five-because.component.html',
  styleUrls: ['./method-five-because.component.scss']
})
export class MethodFiveBecauseComponent implements OnInit, OnChanges {

    constructor(private modalService: NgbModal) { }

    @Input() data: MCause[];
    @Input() title: string;
    @Input() readOnly: boolean = false;

    @Output() removeMethod = new EventEmitter();
    @Output() updateMethod = new EventEmitter();
    @Output() emitCauses = new EventEmitter();

    public fiveWhys: MFiveWhys[] = [];

    ngOnInit() {
        // this.loadCauses()
        // console.log(this.data)
    }

    ngOnChanges() {
        // console.log(this.data)
        this.loadCauses()
    }

    public loadCauses(){
        if (this.data) {
            if (this.data.length > 0) {
                this.fiveWhys = []
                for (let i = 0; i < this.data.length; i++) {
                    if (!this.data[i].fatherId) {
                        this.fiveWhys.push(this.generate(this.data[i]))   
                    }
                }
                for (let i = 0; i < this.data.length; i++) {
                    for (let j = 0; j < this.fiveWhys.length; j++) {
                        if (this.fiveWhys[j].whys[this.fiveWhys[j].whys.length - 1].id === this.data[i].fatherId) {
                            this.fiveWhys[j].whys.push(this.data[i])
                            this.fiveWhys[j].selectedCause = this.fiveWhys[j].whys.length - 1
                        }
                    }
                }
                this.emitData()
            } else {
                this.fiveWhys.push(this.generate())
            }

        } else {
            this.fiveWhys.push(this.generate())
        }
    }

    public add() {
        this.fiveWhys.push(this.generate())
        this.emitData()
    }

    remove(data) {
        this.removeMethod.emit({
            id: 2,
            nombre: this.title
        });
        this.updateMethod.emit(false);
    }

    selectRadio(data) {
        // data.metodo_abierto = 'Análisis de los 5 por qué';
        // data.key = 'five';
        // data.elegido = '';
        // this.value[data.num] = data;

        // this.treatmentService.causeLista.five = this.value;
        // this.treatmentService.setCauseList(this.treatmentService.causeLista);
        // this.updateMethod.emit(false);
    }

    public generate(cause: MCause = null):MFiveWhys{
        // return {
        //     becauses: [{
        //         description: '',
        //         index: 0
        //     }],
        //     selectedCause: 0,
        //     index: this.fiveWhys.length
        // }
        if (cause) {
            const f = new MFiveWhys({
                causa_escogida: 0,
                causas: []
            })
            f.whys.push(cause)
            return f
        } else {
            return new MFiveWhys({
                causa_escogida: 0,
                causas: [
                    {
                        descripcion: '',
                        metodo_analisis: {
                            id: 2,
                            nombre: "treatment.methods.because.title"
                        }
                    }
                ]
            })
        }
    }

    public addItem(index: number){
        // if (this.fiveWhys[index].whys.length <= 4) {
        this.fiveWhys[index].whys.push( new MCause({regular:{descripcion: '', metodo_analisis:{
            id: 2,
            nombre: "treatment.methods.because.title"
        }}}))
        this.fiveWhys[index].selectedCause = this.fiveWhys[index].whys.length - 1
        // }
        setTimeout(()=>{
            document.getElementById('input-' + index + '-' + (this.fiveWhys[index].whys.length - 1)).focus()
        }, 50)
        // console.log(this.fiveWhys)
        this.emitData()
    }

    public deleteItem(index: number, position: number, modal){

        this.modalService.open(modal, {centered: true}).result.then(()=>{
            if (position === 0) {
                this.fiveWhys.splice(index, 1)
                for (let i = 0; i < this.fiveWhys.length; i++) {
                    this.fiveWhys[i].index = i                    
                }
            } else {
                this.fiveWhys[index].whys.splice(position, this.fiveWhys[index].whys.length)
                
                this.fiveWhys[index].selectedCause = this.fiveWhys[index].whys.length - 1
                
            }
            this.emitData()
        }, () => {})

    }

    public emitData(){
        // console.log(this.fiveWhys)
        let definitiveCauses: MCause[] = []
        let allCauses: MCauseArray[] = []
        for (let i = 0; i < this.fiveWhys.length; i++) {
            allCauses.push(new MCauseArray([]))
            for (let j = 0; j < this.fiveWhys[i].whys.length; j++) {
                if (this.fiveWhys[i].whys[j].description != '') {
                    // let cause: MCause = new MCause({regular:{
                    //     descripcion: this.fiveWhys[i].whys[j].description,
                    //     metodo_analisis: method,
                    //     id: this.fiveWhys[i].whys[j].id
                    // }})
                    allCauses[i].causes.push(this.fiveWhys[i].whys[j])
                    if (this.fiveWhys[i].selectedCause == j) {
                        this.fiveWhys[i].whys[j].definitiveSelected = 
                            this.fiveWhys[i].whys[j].definitiveId ? 
                            this.fiveWhys[i].whys[j].definitiveSelected : true;
                        definitiveCauses.push(this.fiveWhys[i].whys[j])
                    }
                }
            }
        }
        // console.log(causes)
        this.emitCauses.emit({
            data: {
                definitive: definitiveCauses,
                causes: allCauses
            }, 
            id: 2
        })
    }

    public onEnter(event, index:number){
        this.emitData()
        if(event.keyCode === 13){
            if (this.fiveWhys[index].whys[this.fiveWhys[index].whys.length - 1].description !== '') {
                this.addItem(index)
            }
        }
    }
}
